import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule, Routes } from '@angular/router';
import { InformationDialogModule } from '../shared/dialog/information-dialog/information-dialog.module';
import { FrameComponent } from './frame/frame.component';
import { OverflowMenuComponent } from './overflow-menu/overflow-menu.component';
import { WizardProgressBannerComponent } from './wizard-progress-banner/wizard-progress-banner.component';
import { ProfileSplashComponent } from './profile-splash/profile-splash.component';

const routes: Routes = [];

@NgModule({
  declarations: [FrameComponent, OverflowMenuComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatTabsModule,
    MatIconModule,
    InformationDialogModule,
    MatListModule,
    WizardProgressBannerComponent,
    ProfileSplashComponent
  ]
})
export class FrameModule { }

export { FrameComponent } from './frame/frame.component';

